import { Instance } from 'mobx-state-tree';
import { CustomFieldPreferencesDtoModelBase } from './CustomFieldPreferencesDtoModel.base';

/* The TypeScript type of an instance of CustomFieldPreferencesDtoModel */
export interface CustomFieldPreferencesDtoModelType extends Instance<typeof CustomFieldPreferencesDtoModel.Type> {}

/* A graphql query fragment builders for CustomFieldPreferencesDtoModel */
export { selectFromCustomFieldPreferencesDto, customFieldPreferencesDtoModelPrimitives, CustomFieldPreferencesDtoModelSelector } from './CustomFieldPreferencesDtoModel.base';

/**
 * CustomFieldPreferencesDtoModel
 */
export const CustomFieldPreferencesDtoModel = CustomFieldPreferencesDtoModelBase
  .actions(self => ({
    // This is an auto-generated example action.
    log() {
      console.log(JSON.stringify(self));
    },
  }));
